import {APIError} from "./apiError";


export const errorParser = (e, t) => {
    let notification = {
        title: t ? t("errors:unknownError") : "Unknown error",
        messages: [],
    };

    // If notification is not define return
    if (!e) {
        notification.title = t ? t("errors:applicationError") : "Error";
        notification.messages = [t ? t("errors:undefinedError") : "Undefined error"];
        return notification;
    }

    if (e instanceof APIError) {
        notification.title = e.title || (t ? t("errors:serverError") : "Server error");
        notification.messages = e.message ? [e.message] : (e.descriptionsArray?.length > 0 ? e.descriptionsArray : [t ? t("errors:aServerErrorHasOccurred") : "A server error has occurred"]);
    } else if (e instanceof Error) {
        notification.title = t ? t("errors:applicationError") : "Error";
        notification.messages = e.message ? [e.message] : [t ? t("errors:anApplicationErrorHasOccurred") : "An application error has occurred"];
    } else if (typeof e === "string") {
        notification.title = t ? t("errors:applicationError") : "Error";
        notification.messages = [e]
    }

    return notification;
};